import React from "react";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import { AuthenticationResult, EventType, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import "./index.css";
import "react-toastify/dist/ReactToastify.min.css";
import { msalConfig } from "./msalConfig";
import initSentry from "./services/sentry";

initSentry();

export const msalInstance = new PublicClientApplication(msalConfig)

if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

type IdTokenClaims = {
  roles: string[];
};

const REQUIRED_SCOPE = import.meta.env.VITE_REQUIRED_SCOPE;

msalInstance.addEventCallback(event => {
  const payload = event.payload as AuthenticationResult;
  if (event.eventType === EventType.LOGIN_SUCCESS && payload.account) {
    const account = payload.account;
    msalInstance.setActiveAccount(account);
    if (
      !(payload.idTokenClaims as IdTokenClaims)?.roles?.includes(REQUIRED_SCOPE)
    ) {
      msalInstance.logoutPopup();
    }
  }
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <> 
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
    <ToastContainer />
  </>
);
